module.exports = __webpack_public_path__ + "img/1463466271.daf68e62.jpg";